
function showinfo() {
  const preorder_info = document.querySelector('.preorder-availability-info');
  const preorder_qty_span = document.querySelector('.preorder-qty-text');
   const select = document.querySelector('.select__select');
  if (!select) return;

  const selectedOption = select.options[select.selectedIndex];

  const showinfo_state = selectedOption.dataset.showinfo;
  const preorder_qty = selectedOption.dataset.preorderqty;
  const showinfo = showinfo_state === "true";
  // =====================
  // SHOW / HIDE INFO
  // =====================
  if (preorder_info) {

    if (showinfo) {
      preorder_info.classList.add('show');
      if (preorder_qty_span) {
        preorder_qty_span.innerText = preorder_qty;
      }
    } else {
      preorder_info.classList.remove('show');
    }

  }
}
function updatePreordertext() {
  const button = document.querySelector('.product-form__submit');
  
  
  if (!button) return;

  const select = document.querySelector('.select__select');
  if (!select) return;

  const selectedOption = select.options[select.selectedIndex];

  const state = selectedOption.dataset.preorder;
  


  const isPreorder = state === "preorder";
  const isSoldOut = state === "soldout";
  

  

  // =====================
  // PREORDER
  // =====================
  if (isPreorder) {
    button.textContent = window.variantStrings.preOrder 
    button.disabled = false;
    button.setAttribute("data-pre-order", "true");
    button.classList.add("preorder-btn");
    return;
  }

  // =====================
  // SOLD OUT
  // =====================
  if (isSoldOut) {
    button.textContent = window.variantStrings.soldOut 
    button.disabled = true;
    button.removeAttribute("data-pre-order");
    button.classList.remove("preorder-btn");
    return;
  }

}
const button = document.querySelector('.product-form__submit');

if (button) {

  let lastDisabledState = button.disabled;

  const observer = new MutationObserver(() => {

    const isDisabled = button.disabled;

    // ONLY trigger when disabled → enabled
    if (lastDisabledState === true && isDisabled === false) {
      updatePreordertext();
    } else {
      setTimeout(() => {
        showinfo();
      }, 50);
    }

    lastDisabledState = isDisabled;

  });

  observer.observe(button, {
    attributes: true,
    attributeFilter: ['disabled']
  });
}